<div provide-parent-form *ngIf="adunit?.playout">
	<h3>{{ 'AD_UNIT_SETTINGS' | translate }}</h3>

	<bb-form-element [form]="form" invalidMessage="The title is required" [label]="'TITLE' | translate">
		<bb-text [(ngModel)]="adunit.title" required (ngModelChange)="titleUpdatedSubject.next($event)" name="title">
		</bb-text>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'CODE' | translate">
		<bb-text [class.disabled]="!isNew" [(ngModel)]="adunit.code" (ngModelChange)="codeUpdatedSubject.next($event)"
			name="code"></bb-text>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'DESCRIPTION' | translate">
		<textarea [(ngModel)]="adunit.description" name="description"></textarea>
	</bb-form-element>

	<bb-form-element *ngIf="lineitem" [form]="form" [label]="'VMAP_URL' | translate">
		<bb-text [(ngModel)]="lineitem.vast_url" (ngModelChange)="lineitemUpdated.next();" name="vast_url"></bb-text>
	</bb-form-element>

	<h3>{{ 'CTA_SETTINGS' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'CTA_TEXT' | translate" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
		<bb-text [(ngModel)]="adunit.playout.ctaText" name="playout-ctaText"></bb-text>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'MIDPLAY_CTA' | translate" [helpMessage]="'HELP.MIDPLAY_CTA' | translate" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
		<bb-select [(ngModel)]="adunit.playout.ctaMidplay" [options]="ctaMidplayOptions" name="playout-ctaMidplay">
		</bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'MIDPLAY_CTA_POSITION' | translate" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
		<bb-select [(ngModel)]="adunit.playout.ctaMidplayPosition" [options]="ctaMidplayPositionOptions"
			name="playout-ctaMidplayPosition">
		</bb-select>
	</bb-form-element>

	<bb-form-element *ngIf="outstream" [form]="form" [label]="'EXITSCREEN_CTA' | translate" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
		<bb-select [(ngModel)]="adunit.playout.ctaExitScreen" [options]="ctaMidplayExitScreenOptions"
			name="playout-ctaExitScreen">
		</bb-select>
	</bb-form-element>

	<ng-container
		*ngIf="adunit?.playout?.ctaExitScreen === 'show' || adunit?.playout?.ctaExitScreen === 'show_nonCompanion'">
		<ng-container *ngIf="adunit?.playout?.ctaMidplay === 'show' || adunit?.playout?.ctaMidplay === 'show_nonVPAID'" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
			<bb-form-element [form]="form" [label]="'CTA_BACKGROUND_COLOR' | translate">
				<bb-color-picker-box [(ngModel)]="adunit.playout.ctaBackgroundColor" [pickerPosition]="'left'"
					name="playout-ctaBackgroundColor" [colorPresets]="usedColors" [excludeHexHash]="true">
				</bb-color-picker-box>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'CTA_HIGHLIGHT_COLOR' | translate" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
				<bb-color-picker-box [(ngModel)]="adunit.playout.ctaHighlightColor" [pickerPosition]="'left'"
					name="playout-ctaHighlightColor" [colorPresets]="usedColors" [excludeHexHash]="true">
				</bb-color-picker-box>
			</bb-form-element>
		</ng-container>

		<bb-form-element [form]="form" [label]="'CTA_EXIT_SCREEN_SHADE' | translate" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
			<bb-check [(ngModel)]="adunit.playout.ctaExitScreenShade" name="playout-ctaExitScreenShade" trueValue="true"
				falseValue="false"></bb-check>
		</bb-form-element>
	</ng-container>

	<div [hasPublicationField]="'eventHanders'">
		<h3>{{ 'EVENT_HANDLERS' | translate }}</h3>

		<bb-event-handlers name="playout-eventHandlers" [(ngModel)]="adunit.playout.eventHandlers"></bb-event-handlers>
	</div>

	<div [hasPublicationField]="'rootOnly'" style="display: none;">
		<!-- This part will stay root only so no translation keys needed. You can enter any key to see or save its value. -->
		<h3>Root only key values</h3>
		<bb-form-element [form]="form">
			<label>adunit key/value</label>
			<div class="input">
				<input type="text" [(ngModel)]="keyValue" style="width: 48%;" placeholder="key"
					[ngModelOptions]="{standalone: true}" />
				<input type="text" [(ngModel)]="adunit[keyValue]" placeholder="value" style="width: 48%;"
					[ngModelOptions]="{standalone: true}" />
			</div>
		</bb-form-element>
		<bb-form-element [form]="form">
			<label>adunit.playout key/value</label>
			<div class="input">
				<input type="text" [(ngModel)]="playoutKeyValue" style="width: 48%;" placeholder="playout key"
					[ngModelOptions]="{standalone: true}" />
				<input type="text" [(ngModel)]="adunit.playout[playoutKeyValue]" placeholder="playout value"
					style="width: 48%;" [ngModelOptions]="{standalone: true}" />
			</div>
		</bb-form-element>
	</div>

	<h3>
		{{ getPositionTitle() }} {{ 'SETTINGS' | translate | lowercase }}
	</h3>

	<p *ngIf="instream">
		{{ 'CHOOSE_PLAYOUT_MEDIACLIP_ADUNIT_WILL_RUN_ON' | translate }}
	</p>

	<bb-form-element *ngIf="instream || position" [form]="form" [label]="'PLAYOUT' | translate"
		[class.disabled]="adunit?.clipId">
		<bb-entity-selector [entityType]="'playout'" [(ngModel)]="adunit.playoutCode" name="playoutCode" [filterSet]="[{
			filters: [{
				type: 'playout',
				field: 'status',
				operator: 'isNot',
				value: 'inactive'
			}]
		}]"></bb-entity-selector>
	</bb-form-element>

	<bb-form-element *ngIf="instream" [form]="form" [label]="'MEDIACLIP' | translate"
		[class.disabled]="adunit?.playoutCode">
		<bb-entity-selector [entityType]="'mediaclip'" [(ngModel)]="adunit.clipId" name="clipId"></bb-entity-selector>
	</bb-form-element>

	<ng-container *ngIf="adunit?.positionType === 'vmap' && lineitem?.playout">
		<bb-form-element [form]="form" [label]="'TIMEOUT' | translate">
			<input type="number" [(ngModel)]="lineitem.timeout" (ngModelChange)="lineitemUpdated.next();"
				name="lineitem-timeout">
		</bb-form-element>

		<bb-form-element [hasPublicationField]="'blockInsecureVPAID'" [form]="form"
			[label]="'BLOCK_INSECURE_VPAID' | translate" [helpMessage]="'HELP.BLOCK_INSECURE_VPAID' | translate">
			<bb-check [(ngModel)]="lineitem.playout.blockInsecureVPAID" (ngModelChange)="lineitemUpdated.next();"
				name="lineitem-playout-blockInsecureVPAID" trueValue="true" falseValue="false"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYOUT_COMMERCIAL_BEHAVIOUR' | translate">
			<bb-select [(ngModel)]="lineitem.playout.commercialBehaviour" (ngModelChange)="lineitemUpdated.next();"
				[preset]="'commercialBehaviour'" name="lineitem-playout-commercialBehaviour">
			</bb-select>
		</bb-form-element>
	</ng-container>

	<ng-container *ngIf="outstream">
		<bb-form-element [form]="form" [label]="'OUTSTREAM_REFRESH' | translate"
			[helpMessage]="'HELP.OUTSTREAM_REFRESH' | translate">
			<bb-check [(ngModel)]="adunit.playout.outstreamRefresh" name="playout-outstreamRefresh" trueValue="true"
				falseValue="false"></bb-check>
		</bb-form-element>

		<bb-form-element *ngIf="adunit?.positionType === 'inarticle'" [form]="form"
			[label]="'STICKY_OPTIONS' | translate" [helpMessage]="'HELP.MAKE_INARTICLE_STICKY' | translate">
			<bb-select [(ngModel)]="adunit.playout.stickyMode" [defaultValue]="''" [preset]="'stickyMode'" name="playout-stickyMode">
			</bb-select>
		</bb-form-element>

		<ng-container *ngIf="adunit.playout.stickyMode === 'stickToElement'">
			<bb-form-element [form]="form" [label]="'DOM_FLOAT_ELEMENT' | translate"
				[helpMessage]="'HELP.FLOAT_TO_ELEMENT' | translate">
				<input type="text" name="playout-domFloatElement" [(ngModel)]="adunit.playout.domFloatElement"
					[placeholder]="'ENTER_DOM_ELEMENT_TO_FLOAT_TO' | translate" />
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'DOM_ELEMENT_ALIGNMENT' | translate">
				<bb-select [(ngModel)]="adunit.playout.domElementAlignment" name="playout-domElementAlignment">
					<option value="stickTopLeft">{{ 'FLOAT_TO_TOP_LEFT' | translate }}</option>
					<option value="stickBottomLeft">{{ 'FLOAT_TO_BOTTOM_LEFT' | translate }}</option>
					<option value="stickTopRight">{{ 'FLOAT_TO_TOP_RIGHT' | translate }}</option>
					<option value="stickBottomRight">{{ 'FLOAT_TO_BOTTOM_RIGHT' | translate }}</option>
				</bb-select>
			</bb-form-element>
		</ng-container>

		<ng-container
			*ngIf="adunit.playout.stickyMode === 'stickBottomRight' || adunit.playout.stickyMode === 'stickBottomLeft' || adunit.playout.stickyMode === 'stickTopRight' || adunit.playout.stickyMode === 'stickTopLeft' || adunit.playout.stickyMode === 'stickDownBottomLeft' || adunit.playout.stickyMode === 'stickDownBottomRight' || adunit.playout.stickyMode === 'stickDownTopCenter' || adunit.playout.stickyMode === 'stickToElement'">
			<bb-form-element [form]="form" [label]="'WIDTH_WHEN_FLOATING' | translate"
				[helpMessage]="'HELP.WIDTH_WHEN_FLOATING' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#3-0-inarticle-settings'">
				<textarea [(ngModel)]="adunit.playout.floatingWidth" name="playout-floatingwidth"
					[placeholder]="('ENTER_NUMBER_OR_JAVASCRIPT_RETURNING_NUMBER_JS' | translate) + '; ' + ('LEAVE_BLANK_TO_DISABLE' | translate)"
					rows="1"></textarea>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'MINIMUM_FLOAT_WIDTH' | translate"
				[helpMessage]="'HELP.MINIMUM_FLOAT_WIDTH' | translate">
				<bb-dimension [(ngModel)]="adunit.playout.minimumFloatWidth" name="playout-minimumFloatWidth"
					[useUnits]="'px'" [placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate"></bb-dimension>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'ALWAYS_FLOAT' | translate"
				[helpMessage]="'HELP.ALWAYS_FLOAT' | translate">
				<bb-check [(ngModel)]="adunit.playout.alwaysFloat" name="playout-alwaysFloat" trueValue="true"
					falseValue="false"></bb-check>
			</bb-form-element>

			<bb-form-element *ngIf="adunit.playout.alwaysFloat === 'true'" [form]="form"
				[label]="'SHOW_CLOSE_BUTTON' | translate">
				<bb-check name="playout-showFloatingCloseButton" [(ngModel)]="adunit.playout.showFloatingCloseButton"
					[trueValue]="'true'" [falseValue]="'false'">
				</bb-check>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'DISABLE_FLOAT_ANIMATION' | translate"
				[helpMessage]="'HELP.DISABLE_FLOAT_ANIMATION' | translate">
				<bb-check name="playout-disableFloatAnimation" [(ngModel)]="adunit.playout.disableFloatAnimation"
					[trueValue]="'true'" [falseValue]="'false'"></bb-check>
			</bb-form-element>
		</ng-container>

		<bb-player-aspect-ratio *ngIf="adunit.playout" [form]="form" [(width)]="adunit.playout.width"
			[(height)]="adunit.playout.height" [(aspectRatio)]="adunit.playout.aspectRatio"
			[(responsiveSizing)]="adunit.playout.responsiveSizing" [defaultOption]="'USE_AD_ASPECT_RATIO' | translate">
		</bb-player-aspect-ratio>

		<bb-form-element [label]="'MAXIMUM_WIDTH' | translate">
			<bb-dimension [(ngModel)]="adunit.playout.maxWidth" name="playout-maxWidth" [useUnits]="'px'"
				[placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate"></bb-dimension>
		</bb-form-element>

		<bb-form-element *ngIf="adunit?.positionType === 'inarticle'" [label]="'PLAYOUT_INVIEW_MARGIN' | translate"
			[helpMessage]="'HELP.INVIEW_MARGIN' | translate"
			[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#3-0-inarticle-settings'">
			<bb-dimension [(ngModel)]="adunit.playout.inviewMargin" name="playout-inviewMargin" [useUnits]="'percent'">
			</bb-dimension>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLACEHOLDER_BG_COLOR' | translate"
			[helpMessage]="'HELP.ADUNIT_PLACEHOLDER' | translate">
			<bb-color-picker-box [(ngModel)]="adunit.playout.bgColor" [pickerPosition]="'left'" name="playout-bgColor"
				[colorPresets]="usedColors" [excludeHexHash]="true">
			</bb-color-picker-box>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLACEHOLDER_TEXT_COLOR' | translate" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
			<bb-color-picker-box [(ngModel)]="adunit.playout.placeholderTextColor" [pickerPosition]="'left'"
				name="playout-placeholderTextColor" default="ffffff" [colorPresets]="usedColors"
				[excludeHexHash]="true">
			</bb-color-picker-box>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLACEHOLDER_TEXT' | translate" [class.disabled]="adunit.playout.outstreamRefresh === 'true'">
			<bb-text [(ngModel)]="adunit.playout.placeholderText" name="playout-placeholderText"></bb-text>
		</bb-form-element>
	</ng-container>

	<bb-form-element *ngIf="adunit?.positionType === 'preroll' || adunit?.positionType === 'postroll'" [form]="form"
		[label]="'PLAYOUT_COMMERCIAL_BEHAVIOUR' | translate">
		<bb-select [(ngModel)]="adunit.playout.commercialBehaviour" [defaultValue]="''" [preset]="'commercialBehaviour'"
			name="playout-commercialBehaviour">
		</bb-select>
	</bb-form-element>

	<bb-form-element *ngIf="adunit?.positionType === 'preroll'" [form]="form"
		[label]="'PLAYOUT_MINIMUM_CLIP_DURATION_FOR_PREROLL' | translate">
		<input type="number" [(ngModel)]="adunit.playout.minClipDurationPreroll" name="playout-minClipDurationPreroll"
			[placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate">
	</bb-form-element>

	<bb-form-element *ngIf="adunit?.positionType === 'postroll'" [form]="form"
		[label]="'PLAYOUT_MINIMUM_CLIP_DURATION_FOR_POSTROLL' | translate">
		<input type="number" [(ngModel)]="adunit.playout.minClipDurationPostroll" name="playout-minClipDurationPostroll"
			[placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate">
	</bb-form-element>

	<bb-form-element *ngIf="adunit?.positionType !== 'vmap'" [form]="form"
		[label]="'ALLOW_SKIPPING' | translate">
		<bb-check [(ngModel)]="allowSkipping" (ngModelChange)="updateSkipOffset()"
			[ngModelOptions]="{standalone: true}"></bb-check>
	</bb-form-element>

	<div [hidden]="!allowSkipping">
		<bb-form-element [form]="form" [label]="'SKIP_COUNTDOWN_TEXT' | translate">
			<div class="input">
				<input class="skip-counter-text" type="text" [(ngModel)]="adunit.playout.skipCounterText"
					name="playout-skipCounterText" />
				<input class="skip-counter-offset" type="number" [(ngModel)]="adunit.playout.skipOffset"
					name="playout-skipOffset" /> {{ 'SECONDS' | translate | lowercase }}.
			</div>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'SKIP_BUTTON_TEXT' | translate">
			<input [(ngModel)]="adunit.playout.skipButtonText" type="text" name="playout-skipButtonText" />
		</bb-form-element>
	</div>

	<bb-form-element *ngIf="adunit?.positionType === 'preroll'" [form]="form" [label]="'UPCOMING_VIDEO' | translate">
		<bb-check [(ngModel)]="adunit.playout.upcomingVideo" name="playout-upcomingVideo" trueValue="true"
			falseValue="false"></bb-check>
		<div *ngIf="adunit?.playout?.upcomingVideo === 'true' && allowSkipping">
			<small>{{ 'HELP.UPCOMING_VIDEO_INFO' | translate }}</small>
		</div>
	</bb-form-element>

	<bb-form-element *ngIf="adunit?.playout?.upcomingVideo === 'true' && !allowSkipping" [form]="form"
		[label]="'UPCOMING_TEXT' | translate">
		<bb-text [(ngModel)]="adunit.playout.upcomingText" name="playout-upcomingText"></bb-text>
	</bb-form-element>

	<ng-container *ngIf="outstream">
		<bb-form-element [hasPublicationField]="'adunitAutoMute'" [form]="form" [label]="'AUTOMUTE' | translate">
			<bb-check [(ngModel)]="adunit.playout.autoMute" name="playout-autoMute" trueValue="true" falseValue="false">
			</bb-check>
		</bb-form-element>

		<bb-form-element [hasPublicationField]="'adunitAutoPlay'" [form]="form" [label]="'AUTOPLAY' | translate">
			<bb-check [(ngModel)]="adunit.playout.autoPlay" name="playout-autoPlay" trueValue="true" falseValue="false">
			</bb-check>
		</bb-form-element>
	</ng-container>

	<ng-container *ngIf="!position">
		<h3>{{ 'DISPLAY_SETTINGS' | translate }}</h3>

		<bb-form-element *ngIf="adunit?.positionType === 'preroll' || adunit?.positionType === 'postroll'" [form]="form"
			[label]="'CONTROLS_VISIBILITY' | translate">
			<bb-select [(ngModel)]="adunit.playout.commercialControls" [defaultValue]="'automatic'"
				[preset]="'commercialControls'" name="playout-commercialControls">
			</bb-select>
		</bb-form-element>

	</ng-container>

	<ng-container *ngIf="adunit?.playout?.commercialControls !== 'alwaysHide'">
		<bb-form-element [form]="form" [label]="'PLAYOUT_COMMERCIAL_SHOW_PLAY_PAUSE_BUTTON' | translate">
			<bb-check [(ngModel)]="adunit.playout.commercialPauseButton" name="playout-commercialPauseButton"
				trueValue="true" falseValue="false"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYOUT_COMMERCIAL_SHOW_MUTE_UNMUTE_BUTTON' | translate">
			<bb-check [(ngModel)]="adunit.playout.commercialMuteButton" name="playout-commercialMuteButton"
				trueValue="true" falseValue="false"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYOUT_COMMERCIAL_SHOW_PROGRESS' | translate">
			<bb-check [(ngModel)]="adunit.playout.commercialProgressBar" name="playout-commercialProgressBar"
				trueValue="true" falseValue="false"></bb-check>
		</bb-form-element>

		<bb-form-element [hidden]="adunit?.playout?.commercialProgressBar === 'false'" [form]="form"
			[label]="'PLAYOUT_COMMERCIAL_PROGRESS_COLOR' | translate">
			<bb-color-picker-box [(ngModel)]="adunit.playout.commercialProgressBarColor" [pickerPosition]="'left'"
				name="playout-commercialProgressBarColor" [colorPresets]="usedColors" default="FFCC00"
				[excludeHexHash]="true">
			</bb-color-picker-box>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYOUT_TEXT_COMMERCIAL_TIME_REMAINING' | translate">
			<bb-text [(ngModel)]="adunit.playout.textCommercialTimeRemaining" name="playout-textCommercialTimeRemaining"
				[placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate"></bb-text>
		</bb-form-element>
	</ng-container>

	<bb-form-element [hasPublicationField]="'allowCustomClickLayer'" [form]="form"
		[label]="'PLAYOUT_ALLOW_CUSTOM_CLICKLAYER' | translate"
		[helpMessage]="'HELP.ALLOW_CUSTOM_CLICKLAYER' | translate">
		<bb-check [(ngModel)]="adunit.playout.allowCustomClickLayer" name="playout-allowCustomClickLayer"
			trueValue="true" falseValue="false"></bb-check>
	</bb-form-element>

	<bb-form-element *ngIf="!outstream" [hasPublicationField]="'imaCustomPlaybackForIOS10Plus'" [form]="form"
		[label]="'IMA_CUSTOM_PLAYBACK_IOS10' | translate" [helpMessage]="'HELP.IMA_CUSTOM_PLAYBACK_IOS10' | translate"
		[helpMessageLink]="'https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.ImaSdkSettings.setDisableCustomPlaybackForIOS10Plus'">
		<bb-check [(ngModel)]="adunit.playout.imaCustomPlaybackForIOS10Plus"
			name="playout-imaCustomPlaybackForIOS10Plus" trueValue="true" falseValue="false"></bb-check>
	</bb-form-element>

	<ng-container *ngIf="outstream">
		<bb-form-element [form]="form" [label]="'PLAYOUT_TEXT_ABOVE_PLAYER' | translate">
			<bb-text [(ngModel)]="adunit.playout.textAbovePlayer" name="playout-textAbovePlayer"
				[placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate"></bb-text>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYOUT_TEXT_CLOSE_PLAYER' | translate">
			<bb-text [(ngModel)]="adunit.playout.textCommercialSkip" name="playout-textCommercialSkip"
				[placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate"></bb-text>
		</bb-form-element>

		<div class="show-advanced-options" (click)="adunitShowAdvancedOptions = !adunitShowAdvancedOptions">
			<div class="hairline"></div>
			<span class="advanced-options-text">
				<span class="arrow">
					<i *ngIf="adunitShowAdvancedOptions" class="fas fa-caret-down"></i>
					<i *ngIf="!adunitShowAdvancedOptions" class="fas fa-caret-right"></i>
				</span>
				<span>{{ 'ADVANCED_OPTIONS' | translate }}</span>
			</span>
		</div>

		<ng-container *ngIf="adunitShowAdvancedOptions">
			<h3>{{ 'IN_AND_OUTVIEW' | translate }}</h3>

			<bb-form-element [hasPublicationField]="'startCollapsed'" [form]="form"
				[label]="'START_COLLAPSED' | translate" [helpMessage]="'HELP.AD_UNIT_START_COLLAPSED' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#5-0-in-out-view'">
				<bb-check [(ngModel)]="adunit.playout.startCollapsed" name="playout-startCollapsed" trueValue="true"
					falseValue="false"></bb-check>
			</bb-form-element>

			<bb-form-element [form]="form"
				[label]="'COLLAPSE_ON_END' | translate" [helpMessage]="'HELP.AD_UNIT_COLLAPSE_ON_END' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#5-0-in-out-view'"
				[class.disabled]="adunit.playout.outstreamRefresh === 'true'">
				<bb-check [(ngModel)]="adunit.playout.hidePlayerOnEnd" name="playout-hidePlayerOnEnd"
					trueValue="true" falseValue="false"></bb-check>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'IN_VIEW_ACTION' | translate">
				<bb-select [(ngModel)]="adunit.playout.interactivity_inView" [preset]="'interactivityInview'"
					name="playout-interactivity_inView">
				</bb-select>
			</bb-form-element>

			<bb-form-element [disabled]="adunit.playout.stickyMode === 'stickBottomRight' || adunit.playout.stickyMode === 'stickBottomLeft' || adunit.playout.stickyMode === 'stickTopRight' ||
			adunit.playout.stickyMode === 'stickTopLeft' || adunit.playout.stickyMode === 'stickBoth'" [form]="form"
				[label]="'OUT_VIEW_ACTION' | translate" [helpMessage]="'HELP.STICKY_OUTVIEW' | translate">
				<bb-select [(ngModel)]="adunit.playout.interactivity_outView" [preset]="'interactivityOutview'"
					name="playout-interactivity_outView">
				</bb-select>
			</bb-form-element>

			<bb-form-element [hasPublicationField]="'forceInview'" [form]="form"
				[label]="'FORCE_INVIEW_ACTIONS' | translate" [helpMessage]="'HELP.FORCE_INVIEW_ACTIONS' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#5-0-in-out-view'">
				<bb-check [(ngModel)]="adunit.playout.forceInview" name="playout-forceInview" trueValue="true"
					falseValue="false"></bb-check>
			</bb-form-element>

			<h3>{{ 'MOUSE' | translate }}</h3>

			<bb-form-element [form]="form" [label]="'MOUSE_IN_ACTION' | translate">
				<bb-select [(ngModel)]="adunit.playout.interactivity_mouseIn" [defaultValue]="'unmute'"
					[preset]="'interactivityInview'" name="playout-interactivity_mouseIn">
				</bb-select>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'MOUSE_OUT_ACTION' | translate">
				<bb-select [(ngModel)]="adunit.playout.interactivity_mouseOut" [defaultValue]="'mute'"
					[preset]="'interactivityOutview'" name="playout-interactivity_mouseOut">
				</bb-select>
			</bb-form-element>

			<bb-form-element [hasPublicationField]="'blockInsecureVPAID'" [form]="form"
				[label]="'BLOCK_INSECURE_VPAID' | translate" [helpMessage]="'HELP.BLOCK_INSECURE_VPAID' | translate">
				<bb-check [(ngModel)]="adunit.playout.blockInsecureVPAID" name="playout-blockInsecureVPAID"
					trueValue="true" falseValue="false"></bb-check>
			</bb-form-element>

			<h3>{{ 'PLACEMENT_OPTIONS' | translate }}</h3>

			<ng-container *ngIf="adunit?.playout?.stickyMode">
				<bb-form-element [form]="form" [label]="'DISTANCE_FROM_TOP' | translate"
					[helpMessage]="'HELP.DISTANCE_FROM_TOP' | translate"
					[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#7-0-placement-options'">
					<textarea [(ngModel)]="adunit.playout.distanceFromTop" name="playout-distanceFromTop"
						[placeholder]="('ENTER_NUMBER_OR_JAVASCRIPT_RETURNING_NUMBER_JS' | translate) + '; ' + ('LEAVE_BLANK_TO_DISABLE' | translate)"
						rows="1"></textarea>
				</bb-form-element>

				<bb-form-element [form]="form" [label]="'DISTANCE_FROM_BOTTOM' | translate"
					[helpMessage]="'HELP.DISTANCE_FROM_BOTTOM' | translate"
					[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#7-0-placement-options'">
					<textarea [(ngModel)]="adunit.playout.distanceFromBottom" name="playout-distanceFromBottom"
						[placeholder]="('ENTER_NUMBER_OR_JAVASCRIPT_RETURNING_NUMBER_JS' | translate) + '; ' + ('LEAVE_BLANK_TO_DISABLE' | translate)"
						rows="1"></textarea>
				</bb-form-element>
			</ng-container>

			<bb-form-element [form]="form" [label]="'PLAYOUT_PLACEMENT_OPTION' | translate"
				[helpMessage]="'HELP.PLACEMENT_OPTION' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#7-0-placement-options'">
				<bb-select [(ngModel)]="adunit.playout.placementOption" [defaultValue]="''"
					[preset]="'placementOption'" name="playout-placementOption">
				</bb-select>
			</bb-form-element>

			<bb-form-element *ngIf="adunit?.playout?.placementOption !== 'default'" [form]="form"
				[label]="'PLAYOUT_PLACEMENT_DOM_SELECTOR' | translate"
				[helpMessage]="'HELP.PLACEMENT_DOM_SELECTOR' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#7-0-placement-options'">
				<bb-text [(ngModel)]="adunit.playout.placementDOMSelector" name="playout-placementDOMSelector">
				</bb-text>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'WAIT_FOR_CMP' | translate"
				[helpMessage]="'HELP.PLACEMENT_WAIT_FOR_CMP' | translate" [helpMessageLink]="'GET_THIS_IN'">
				<bb-check name="playout-waitForCmp" [(ngModel)]="adunit.playout.waitForCmp" [trueValue]="'true'"
					[falseValue]="'false'">
				</bb-check>
			</bb-form-element>

			<bb-form-element *ngIf="adunit?.playout?.waitForCmp === 'true'" [form]="form"
				[label]="'CMP_TIMEOUT' | translate" [helpMessage]="'HELP.CMP_TIMEOUT' | translate"
				[helpMessageLink]="'GET_THIS_IN'">
				<input type="number" name="playout-cmpTimeout" [(ngModel)]="adunit.playout.cmpTimeout"
					[placeholder]="'10000' | translate" min="0" [formControl]="cmpTimeoutFormControl" />
			</bb-form-element>

			<bb-form-element [hasPublicationField]="'iframeBreakout'" [form]="form"
				[label]="'PLAYOUT_IFRAME_BREAKOUT' | translate" [helpMessage]="'HELP.IFRAME_BREAKOUT' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#7-0-placement-options'">
				<bb-check [(ngModel)]="adunit.playout.iframeBreakout" name="playout-iframeBreakout" trueValue="true"
					falseValue="false"></bb-check>
			</bb-form-element>

			<bb-form-element [form]="form"
				[label]="'PLAYOUT_CLEAR_BOTH_OPTION' | translate" [helpMessage]="'HELP.CLEAR_BOTH_OPTION' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#7-0-placement-options'">
				<bb-select [(ngModel)]="adunit.playout.clearBothOption" [defaultValue]="'never'"
					[preset]="'clearBothOption'" name="playout-clearBothOption">
				</bb-select>
			</bb-form-element>

			<h3>{{ 'MISCELLANEOUS_OPTIONS' | translate }}</h3>

			<bb-form-element [hasPublicationField]="'isolatePlayer'" [form]="form"
				[label]="'ISOLATE_PLAYER_STYLING' | translate"
				[helpMessage]="'HELP.ISOLATE_PLAYER_STYLING' | translate">
				<bb-check [(ngModel)]="adunit.playout.isolatePlayer" name="playout-isolatePlayer" trueValue="true"
					falseValue="false"></bb-check>
			</bb-form-element>

			<bb-form-element [hasPublicationField]="'waitForPageReady'" [form]="form"
				[label]="'WAIT_FOR_PAGE_READY' | translate">
				<bb-check [(ngModel)]="adunit.playout.waitForPageReady" name="playout-waitForPageReady" trueValue="true"
					falseValue="false"></bb-check>
			</bb-form-element>

			<bb-form-element [form]="form"
				[label]="'PLAYOUT_PRELOAD_LINE_ITEMS' | translate" [helpMessage]="'HELP.PRELOAD_LINE_ITEMS' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#8-0-miscellaneous'">
				<bb-check [(ngModel)]="adunit.playout.preloadMainroll" name="playout-preloadMainroll" trueValue="true"
					falseValue="false"></bb-check>
			</bb-form-element>

			<bb-form-element [hasPublicationField]="'playInOverlay'" [form]="form"
				[label]="'PLAY_IN_OVERLAY' | translate" [helpMessage]="'HELP.PLAY_IN_OVERLAY' | translate">
				<bb-check [(ngModel)]="adunit.playout.playInOverlay" name="playout-playInOverlay" trueValue="true"
					falseValue="false"></bb-check>
			</bb-form-element>

			<bb-form-element [hasPublicationField]="'customCode'" [form]="form"
				[label]="'PLAYOUT_CUSTOM_CODE' | translate" [helpMessage]="'HELP.CUSTOM_CODE' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#8-0-miscellaneous'">
				<bb-code-editor name="playout-customCode" [(ngModel)]="adunit.playout.customCode"></bb-code-editor>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'PASSBACK_CODE' | translate"
				[helpMessage]="'HELP.PASSBACK_CODE' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/outstreamads/outstream-ads-ad-unit-general-settings/#8-0-miscellaneous'">
				<bb-code-editor name="playout-passbackCode" [(ngModel)]="adunit.playout.passbackCode"></bb-code-editor>
			</bb-form-element>
		</ng-container>
	</ng-container>
</div>
